export default "__VITE_ASSET__C8I5rpLY__"